import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';
export const GOOGLE_MAPS_FALLBACK = "https://www.google.com/maps/search/?api=1&query=Cardoso+Bouw+en+Onderhoud";

const EMPTY = { reviews: [], rating: 0, total_reviews: 0, maps_url: GOOGLE_MAPS_FALLBACK, place_id: "" };
let reviewsPromise = null;

function fetchReviews() {
  if (!reviewsPromise) {
    reviewsPromise = axios.get(`${API}/reviews`).then((res) => ({ ...EMPTY, ...res.data })).catch(() => EMPTY);
  }
  return reviewsPromise;
}

export function useGoogleReviews() {
  const [data, setData] = useState(EMPTY);
  useEffect(() => {
    let active = true;
    fetchReviews().then((d) => { if (active) setData(d); });
    return () => { active = false; };
  }, []);
  return data;
}

export function writeReviewUrl(placeId) {
  return placeId ? `https://search.google.com/local/writereview?placeid=${placeId}` : GOOGLE_MAPS_FALLBACK;
}
